app.component("videoCard", {
  templateUrl: "template/components/videoCard.html",
  bindings: {
    content: "=",
  },
  transclude: true,
});
